module.exports = __webpack_public_path__ + "img/home-13.4afafc53.png";